var map = {
	"./cataract-surgery.json": [
		3414,
		414
	],
	"./contoura-vision.json": [
		6219,
		219
	],
	"./diabetic-retinopathy.json": [
		4484,
		484
	],
	"./femto-lasik-surgery.json": [
		413,
		413
	],
	"./glaucoma-surgery.json": [
		46,
		46
	],
	"./icl-surgery.json": [
		6305,
		305
	],
	"./lasik-eye-surgery.json": [
		9593,
		593
	],
	"./phaco-surgery.json": [
		1012,
		12
	],
	"./prk-lasik-surgery.json": [
		3143,
		143
	],
	"./retinal-detachment.json": [
		1778,
		778
	],
	"./smile-lasik-surgery.json": [
		6148,
		148
	],
	"./squint-surgery.json": [
		4415,
		415
	],
	"./vitrectomy-surgery.json": [
		6567,
		567
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1400;
module.exports = webpackAsyncContext;